export function handleTopLevelRedirects(currentPath: string): string | null {
  if (!currentPath.startsWith('/p/')) {
    return null;
  }

  return currentPath.replace(/\/p\//, '/page/');
}
